module.exports = __webpack_public_path__ + "static/media/NHS_logo.ded9fbb9.svg";